import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // skip /me while the OAuth callback exchanges the session_id
    if (window.location.hash.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  // session lives only in the httpOnly cookie set by the backend
  const signIn = useCallback(async () => { await refresh(); }, [refresh]);

  const signOut = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn("Logout request failed; clearing local session anyway", e);
    }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, refresh, signIn, signOut }), [user, refresh, signIn, signOut]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
